import { Block, Document, Inline, Text } from '@contentful/rich-text-types';
import { Asset, Entry } from 'contentful';

export interface Offer {
  createdAt: string;
  slug: string;
  heroImage: string;
  logo?: string;
  id: string;
  companyName: string;
  externalUrl?: string;
  offerTitle: string;
  offerImage?: string;
  offerStrikeThroughText?: string;
  offerSolidText?: string;
  offerUrl: string;
  content: Content[];
  labels?: string;
}

export enum OfferType {
  CONSUMER_OFFER = 'consumerOffer',
  PROVIDER_OFFER = 'providerOffer',
}

export enum ContentType {
  IMAGE_CONTENT = 'imageContent',
  TEXT_CONTENT = 'textContent',
  RICH_CONTENT = 'richContent',
}

interface ContentCommon {
  type: ContentType;
}

export interface TextContent extends ContentCommon {
  type: ContentType.TEXT_CONTENT;
  extract?: string;
  text: string;
}

export interface ImageContent extends ContentCommon {
  type: ContentType.IMAGE_CONTENT;
  image: string;
  extract: string;
  text: string;
}

export interface RichContent extends ContentCommon {
  type: ContentType.RICH_CONTENT;
  richText: Document;
}

export type Content = TextContent | ImageContent | RichContent;

export type BlockNode = Block | Inline | Text;

export interface RawImageContent {
  image: Asset;
  extract: string;
  text: string;
}

export type RawContent = TextContent | RawImageContent | RichContent;

export interface RawOffer {
  slug: string;
  heroImage: Asset;
  logo?: Asset;
  companyName: string;
  offerTitle: string;
  offerImage?: Asset;
  offerStrikeThroughText?: string;
  offerSolidText?: string;
  offerUrl: string;
  content: Entry<RawContent>[];
  labels?: string;
}
